import { render, staticRenderFns } from "./collected-report.vue?vue&type=template&id=51d80411&"
import script from "./collected-report.vue?vue&type=script&lang=js&"
export * from "./collected-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports